/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'available': {
    width: 194,
    height: 186,
    viewBox: '0 0 194 186',
    data: '<path pid="0" d="M176.36 17.714h-26.45V0h-17.64v53.143h17.64V35.429h26.45v132.857H17.64V35.429h17.63V17.714H17.64A17.68 17.68 0 000 35.429v132.857A17.679 17.679 0 0017.64 186h158.72A17.679 17.679 0 00194 168.286V35.429a17.68 17.68 0 00-17.64-17.715zm-52.91 0H61.73V0H44.09v53.143h17.64V35.429h61.72V17.714zM88.18 145.382l-32.69-32.834 12.47-12.524 20.22 20.308 37.86-38.023 12.47 12.524z" fill-rule="evenodd"/>'
  }
})
